import React from 'react';
import PropTypes from 'prop-types';

import Spin from 'components/ui/Spin';

const propTypes = {
  loading: PropTypes.bool.isRequired,
};

const WithLoading = (Component) => {
  const wrapper = ({ loading, ...rest }) => {
    if (loading) {
      return <Spin />;
    }

    return <Component {...rest} />;
  };

  wrapper.propTypes = propTypes;
  return wrapper;
};

export default WithLoading;



// WEBPACK FOOTER //
// ./src/components/WithLoading.js